import React from "react";

import './logo.scss';

const Logo = ({data}) => {
  const {src, alt} = data;
  return <a href="/" className="logo"><img src={src} alt={alt} /></a>;
}

export default Logo;